import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "./config";
import Navbar from "./components/Navbar";

function ValidateToken() {
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    async function verifyToken() {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/verify_code`,
          { code: token }, // Send code as data in the body of the POST request
          { withCredentials: true }
        );

        if (response.status === 200) {
          // Redirect to the dashboard if the token is valid
          navigate("/dashboard");
        }
      } catch (error) {
        console.error("Invalid or expired code.");
        navigate("/login"); // Redirect to the login page on failure
      }
    }

    verifyToken();
  }, [token, navigate]);

  return (
    <div>
      <Navbar />
      <p>Verifying your code, please wait...</p>
    </div>
  );
}

export default ValidateToken;
